import {
  Box,
  Button,
  Checkbox,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import UserCard from "./UserCard";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import DataService from "../../../../../../Service";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../../../Components/Snackbar/SnackbarActions";

const useStyles = makeStyles((theme) => ({
  in_active: {
    backgroundColor: "#CECFD0",
    color: "#707070",
  },
}));

function Chemistry(props) {
  const classes = useStyles();
  const [checked, setChecked] = useState([]);
  const [checkedAllState, setCheckedAllState] = useState();
  const [pageData, setPageData] = useState([]);
  const [checkedLength, setCheckedLength] = useState([]);
  var localArr = [];
  const dispatch = useDispatch();

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  useEffect(() => {
    getCoachList();
  }, []);

  const getCoachList = () => {
    DataService.getDirectData("shortlisting_coaches/fetch_chemistry_coaches", {
      assignment_id: props.location.state.currentAssignment.id,
    }).then((res) => {
      pageData.length = 0;
      setPageData(pageData.concat(res.chemistry_coaches));
      let dateString = " ";
      if (res.shortlist_email_date) {
        const newDate = new Date(res.shortlist_email_date);
        dateString = `${new Intl.DateTimeFormat("en-US", {
          month: "long",
        }).format(newDate)} ${newDate.getDate()}, ${newDate.getFullYear()}`;
      }
      setShowLastDate({
        show: res.shortlist_email_status || false,
        date: dateString,
      });
    });
  };

  const moveToConfirmed = (params) => {
    var localArr = [];
    // if (Object.keys(checked).length > 1) {
    //     // alert("Please select only one coach")
    //     dispatch(showSnackbar("error", [["" + "Please select only one coach"]]));
    // } else {
    var coachId = "";
    for (const key in checked) {
      if (checked[key]) {
        coachId = key;
      }
    }
    const pdata = {
      assignment_id: props.location.state.currentAssignment.id,
      coach_id: coachId,
    };
    DataService.createData(pdata, "move_to_confirmed")
      .then((res) => {
        if (res?.success) {
          dispatch(
            showSnackbar("Success", ["Coach moved to confirmed successfully"])
          );
          props.setValue(props.value + 1);
        } else {
          dispatch(showSnackbar("error", [["" + res.message]]));
        }
      })
      .catch((err) => {
        // setLoading(false);
        dispatch(showSnackbar("error", [["" + err.message]]));
      });

    // }
  };

  const getArrLengthForClasses = (obj) => {
    for (const key in obj) {
      localArr.push(obj[key]);
    }
    var activeArr = localArr.filter((option) => option == true);
    checkedLength.length = 0;
    setCheckedLength(checkedLength.concat(activeArr));
  };

  const checkHandler = (e) => {
    console.log(e.target.value, typeof e.target.value, pageData);
    let checkedValue = {};
    if (e.target.value === "checkedAll") {
      pageData?.map(
        (data) =>
          (checkedValue[data.coach_id] =
            data.shortlist_type === "chemistry" ? e.target.checked : undefined)
      );
      console.log("checkedAll", checkedValue);
      setCheckedAllState(e.target.checked);
    } else {
      checkedValue = { ...checked, [e.target.value]: e.target.checked };
    }
    setChecked({ ...checked, ...checkedValue });
    getArrLengthForClasses(checkedValue);
  };

  console.log("checked", checked);
  const [showLastDate, setShowLastDate] = useState({ show: false, date: "" });
  const sendSessionsOutcomeHandler = (e) => {
    const params = { assignment_id: props.location.state.currentAssignment.id };
    DataService.getData(params, "outcomesSendEmail")
      .then((res) => {
        if (res?.success) {
          if (!showLastDate.show) {
            const oldDate = new Date().toISOString().slice(0, 10);
            const newDate = new Date(oldDate);
            const dateString = `${new Intl.DateTimeFormat("en-US", {
              month: "long",
            }).format(newDate)} ${newDate.getDate()}, ${newDate.getFullYear()}`;
            setShowLastDate({ show: true, date: dateString });
          }
          dispatch(showSnackbar("Success", ["Email sent successfully"]));
        } else {
          dispatch(showSnackbar("error", [["" + res.message]]));
        }
      })
      .catch((err) => {
        // setLoading(false);
        dispatch(showSnackbar("error", [["" + err.message]]));
      });
  };
  return (
    <Box>
      <Grid container direction="row" spacing={2} alignItems="center">
        {pageData.length > 0 && (
          <>
            <Grid
              item
              xs={1}
              style={{
                justifyContent: "center",
                flexBasis: "0",
              }}
            >
              <Checkbox
                onChange={checkHandler}
                value="checkedAll"
                checked={checkedAllState}
              />
            </Grid>
            <Grid item xs={2}>
              <Typography variant="h2">Select All</Typography>
            </Grid>
            <Grid item xs={9} display="flex">
              <Box fontWeight="fontWeightBold" my={2} textAlign="right">
                <Button
                  disableElevation
                  variant="contained"
                  color="secondary"
                  onClick={moveToConfirmed}
                  className={checkedLength.length == 0 ? classes.in_active : {}}
                  style={{ marginRight: 10, textTransform: "none" }}
                >
                  <PersonOutlineIcon color="#707070" />
                  &nbsp;Move to confirmed
                </Button>
                <Button
                  disableElevation
                  variant="contained"
                  color="secondary"
                  style={{
                    textTransform: "none",
                    backgroundColor: " #07438f ",
                  }}
                  onClick={sendSessionsOutcomeHandler}
                >
                  <MailOutlineIcon />
                  &nbsp;
                  {showLastDate.show
                    ? "Send reminder email for sessions outcome"
                    : "Send email for sessions outcome"}
                </Button>
                <Box style={{ display: "flex", flexDirection: "column" }}>
                  {showLastDate.show && (
                    <Typography variant="body1" style={{ fontSize: "12px" }}>
                      Last email sent on {showLastDate.date}{" "}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>
          </>
        )}
        <Grid item xs={pageData.length > 0 ? 7 : 12}></Grid>
      </Grid>

      {pageData.length > 0 &&
        pageData.map((option) => {
          return (
            <Box mb={2}>
              <Grid container direction="row" spacing={2}>
                <Grid
                  item
                  xs={1}
                  style={{
                    justifyContent: "center",
                    flexBasis: "0",
                    margin: "48px 0px",
                  }}
                >
                  <Checkbox
                    onChange={checkHandler}
                    disabled={option?.shortlist_type === "confirmed"}
                    checked={
                      checked[option.coach_id] === undefined
                        ? false
                        : checked[option.coach_id]
                    }
                    value={option.coach_id}
                    inputProps={{ "aria-label": "primary checkbox" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={11}
                  style={{
                    marginLeft: "0px",
                    border: "solid 1px",
                    borderColor: "#CACED5",
                  }}
                >
                  <UserCard
                    addFeedBackBtn={true}
                    moved={option?.shortlist_type === "confirmed"}
                    buttonText={option?.shortlist_type}
                    {...props}
                    pageData={option}
                    content="chemistry"
                  />
                </Grid>
              </Grid>
            </Box>
          );
        })}
    </Box>
  );
  // <div>
  //    <UserCard/>
  // </div>
}

export default Chemistry;
